<template>
  <div class="join-event">
    <!-- 轮播图 -->
    <div class="swiper-container" ref="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in swiperImg" :key="item.id">
          <a :href="item.href">
            <img :src="item.imgUrl" alt="">
          </a>
        </div>
      </div>
    </div>
    <!-- tab标题 -->
    <div :class="{'tab-title':true,'title-ceil':flagStyle}">
      <span @click="tabTitleState(index)" :class="{'title-active': titleIdx==index}" v-for="(item,index) of tabTitle"
        :key="item.id">{{item.title}}</span>
    </div>
    <!-- 图片 -->
    <div>
      <div class="tab-img">
        <div class="img-box" :class="{'img-active':titleIdx==0}">
          <img v-for="item of eventDetail" :key="item.id" :src="item.imgUrl" alt="">
        </div>
        <div class="img-box" :class="{'img-active':titleIdx==1}">
          <img :src="awardsSetImg" alt="">
        </div>
        <div class="img-box" :class="{'img-active':titleIdx==2}">
          <img :src="applyImg" alt="">
        </div>
      </div>
      <div class="empty-box"></div>
    </div>
    <!-- 我要参赛 -->
    <div class="join-event-button" @click="joinEvent">我要参赛</div>
  </div>
</template>

<script>
  import api from "../utils/apis.js"
  import Swiper from "swiper";
  import "swiper/dist/css/swiper.min.css";
  import wx from 'weixin-js-sdk';
  import Vue from 'vue';
  import {
    Toast
  } from 'vant';

  Vue.use(Toast);
  export default {
    props: {
      // 模板id
      id: {

      },
      // swiperImg
      swiperImg: {

      },
      // 大赛详情图片
      eventDetail: {

      },
      // 奖项设置图片
      awardsSetImg: {},
      // 报名方式图片
      applyImg: {}
    },
    data() {
      return {
        // 选项卡标题
        tabTitle: [{
            id: 1,
            title: "大赛详情"
          },
          {
            id: 2,
            title: "奖项设置"
          },
          {
            id: 3,
            title: "报名方式"
          },

        ],
        // 切换标题索引
        titleIdx: 0,
        // 标题吸顶样式
        flagStyle: false,
        // 微信分享描述
        wx_desc: "",
        // 分享图标
        wx_icon: "",
        // 分享标题
        wx_title: "",
        // 网页标题
        navTitle: "",
      }
    },
    created() {
      // 获取sdk配置参数
      this.getSdkConfig();
      // 获取活动信息
      this.getEventInfo();
    },
    mounted() {
      // 获取轮播图
      this.getSwiper();
      // 监听页面滚动
      this.watchPageScolll();
    },
    methods: {
      /**
       * 获取活动信息
       * @method getEventInfo
       */
      getEventInfo() {
        console.log(this.id, "模板id");
        api.getEventInfo(this.id).then(res => {
          if (res.data.code == 0) {
            this.wx_desc = res.data.data.wx_desc;
            this.wx_icon = res.data.data.wx_icon;
            this.wx_title = res.data.data.wx_title;
            this.navTitle = res.data.data.title;
            // 设置网页标题
            document.title = this.navTitle
            // 分享给好友
            wx.ready(() => { //需在用户可能点击分享按钮前就先调用
              console.log(this.wx_title, "标题");
              wx.updateAppMessageShareData({
                title: this.wx_title, // 分享标题
                desc: this.wx_desc, // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: this.wx_icon, // 分享图标
                success: function () {
                  // 设置成功
                }
              })
            });
            // 分享给朋友圈
            wx.ready(() => { //需在用户可能点击分享按钮前就先调用
              wx.updateTimelineShareData({
                title: this.wx_title, // 分享标题
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: this.wx_icon, // 分享图标
                success: function () {
                  // 设置成功
                }
              })
            });
          }
        })
      },
      /**
       * 获取轮播图实例
       * @method getSwiper
       */
      getSwiper() {
        var swiper = new Swiper('.swiper-container', {
          slidesPerView: "auto",
          spaceBetween: 0.5,
          centeredSlides: true,
          loop: true,
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
        });
      },
      /**
       * 监听页面的滚动
       *@method watchPageScolll
       */
      watchPageScolll() {
        // 获取轮播图的高度
        let bannerHeight = this.$refs.banner.offsetHeight;
        window.onscroll = () => {
          if (window.scrollY >= bannerHeight) {
            this.flagStyle = true;
          } else {
            this.flagStyle = false;
          }
        }
      },
      /**
       * 切换标题
       * @method tabTitleState
       * @param {number} 切换的索引
       */
      tabTitleState(index) {
        this.titleIdx = index;
      },
      /**
       * 我要参赛
       * @method joinEvent
       */
      joinEvent() {
        Toast.loading({
          message: '跳转中...',
          forbidClick: true,
        });
        setTimeout(() => {
          // 摄影大赛
          let shareUrl = encodeURIComponent(window.location.href);
          window.location.href = `https://event.kongquechao.com/view/form/#/?id=${this.id}&shareUrl=${shareUrl}`;
        }, 1000)
      },
      /**
       * 获取sdk配置参数
       * @method getSdkConfig
       */
      getSdkConfig() {
        // 调分享接口获取参数
        api.getSdkConfig(window.location.href).then(res => {
          if (res.data.code == 0) {
            console.log(res, "分享参数");
            wx.config({
              // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.data.data.appId, // 必填，公众号的唯一标识
              timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
              signature: res.data.data.signature, // 必填，签名
              openTagList: ['wx-open-launch-app',
                'wx-open-launch-weapp'
              ], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
              jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的JS接口列表
            });
            wx.error(function (res) {
              console.log("config验证失败");
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  // 轮播图
  .swiper-container {
    width: 100%;
    height: 4.426667rem;
    padding-top: .533333rem;
    box-sizing: border-box;

    .swiper-slide {
      transition: 300ms;
      transform: scale(0.9);
      width: 84% !important;
      height: 3.893333rem !important;
      margin-left: -0.066667rem;

      img {
        width: 100%;
        height: 100%;
        border-radius: .4rem;
      }
    }
  }

  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    transform: scale(1) !important;
  }

  // 标题
  .title-ceil {
    position: fixed;
    top: 0;
    left: 0;
  }

  .tab-title {
    width: 100%;
    padding-top: .413333rem;
    height: .64rem;
    display: flex;
    justify-content: space-around;
    padding-bottom: .346667rem;
    background-color: #fff;

    span {
      display: block;
      width: 2.213333rem;
      height: .64rem;
      color: #000;
      font-size: .413333rem;
      line-height: .64rem;
      text-align: center;
    }

    .title-active {
      background-color: rgb(213, 161, 72);
      border-radius: .4rem;
      color: #fff;
    }

  }

  // 图片
  .tab-img {
    .img-box {
      width: 100%;
      height: 100%;
      display: none;

      img {
        width: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .img-active {
      display: block;
    }
  }

  .empty-box {
    height: 1.306667rem;
  }

  // 我要参赛
  .join-event-button {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 1.306667rem;
    background: rgb(213, 161, 72);
    line-height: 1.306667rem;
    text-align: center;
    color: #FFFFFF;
    font-size: .48rem;
  }
</style>